import React, { useState } from 'react';
import './neighborhoods.scss';

interface Option {
    value: string;
    label: string;
}

const options: Option[] = [
    { value: 'Lévis Centre', label: 'Lévis Centre' },
    { value: 'Vieux-Lévis', label: 'Vieux-Lévis' },
    { value: 'Lauzon', label: 'Lauzon' },
    { value: 'Saint-David-de-l\'Auberivière', label: 'Saint-David-de-l\'Auberivière' },
    { value: 'Charny', label: 'Charny' },
    { value: 'Saint-Romuald', label: 'Saint-Romuald' },
    { value: 'Saint-Nicolas', label: 'Saint-Nicolas' },
    { value: 'Saint-Rédempteur', label: 'Saint-Rédempteur' },
    { value: 'Saint-Jean-Chrysostome', label: 'Saint-Jean-Chrysostome' },
    { value: 'Breakeyville', label: 'Breakeyville' },
    { value: 'Pintendre', label: 'Pintendre' },
    { value: 'Desjardins', label: 'Desjardins' },
    { value: 'Saint-Étienne', label: 'Saint-Étienne' },
];

interface Props {
    onSelect: (value: string) => void;
    currentValue?: string;
}

const Neighborhood: React.FC<Props> = ({ onSelect, currentValue }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState<string | undefined>(currentValue);

    React.useEffect(() => {
        setSelectedValue(currentValue);
    }, [currentValue]);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleOptionClick = (value: string) => {
        onSelect(value);
        setSelectedValue(value);
        setIsOpen(false);
    };

    return (
        <div className="dropdown">
            <button type="button" onClick={toggleDropdown}>
                {selectedValue || 'Choisir un quartier'}
            </button>
            {isOpen && (
                <ul className="dropdown-menu">
                    <li key="all" onClick={() => handleOptionClick("")}>
                        Toutes les quartiers
                    </li>
                    {options.map((option) => (
                        <li key={option.value} onClick={() => handleOptionClick(option.value)}>
                            {option.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default Neighborhood;
